import type { FaireProductEntity } from "../../entity_types/product";

export const p_shwsgju9xk: FaireProductEntity = {
  token: "p_shwsgju9xk",
  type: "product",
  name: "Vintage Farm Square Canister Set  3 pc  52 72 90 oz",
  brandName: "Certified International",
  imageUrl:
    "https://cdn.faire.com/fastly/075cdeb565e1f5d4709b5d58e067f0d36f8d1380f4d0f6d3c1f39812428b4fdf.jpeg",
  priceDollars: 55,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/41eb837e21d82c4c087064eaa05c3ced63cd72325fd7bc2da723063c83980e1c.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
